import NetworkPicker from "views/NetworkPicker";

export const Header = () => (
  <div className="so-back" data-testid="page-header">
    <div className="so-chunk">
      <div className="so-siteHeader LaboratoryChrome__header">
        <span className="so-logo">
          <a href="https://cryptops.exchange/" className="so-logo__main">
            <svg
              width="100"
              height="100"
              className="Navigation__LogoEl-sc-1ng8ds2-1 kCDSHy"
              viewBox="0 0 28 28"
            >
              <g>
                <text font-weight="700" font-size="33.1px" line-height="20.68px" font-family="Malgun Gothic" display="inline" fill="#363636" fill-opacity="1" x="97.5" y="171.8" transform="matrix(1.01272 0 0 .98744 -97.702 -144.648)"><tspan x="97.5" y="171.8" fill="#363636" fill-opacity="1">C</tspan></text>
                <text font-weight="700" font-size="23.5px" line-height="14.71px" font-family="Malgun Gothic" display="inline" fill="#d4af37" fill-opacity="1" x="98.8" y="174" transform="matrix(1.0489 0 0 .96 -97.702 -144.648)"><tspan x="98.8" y="174" fill="#d4af37" fill-opacity="1">O</tspan></text>
                <text font-weight="500" font-size="13.6px" line-height="14.64px" display="inline" fill="#363636" fill-opacity="1" x="108.7" y="161.8" transform="matrix(.9917 -0.0168 0 1.03 -97.2 -144.648)"><tspan x="108.679" y="161.788" fill="#363636" fill-opacity="1">&#949;</tspan></text>
              </g>
            </svg>
          </a>
          <span className="so-logo__separator"> </span>
          <a href="#" className="so-logo__subSite">
            Laboratory
          </a>
        </span>

        <NetworkPicker />
      </div>
    </div>
  </div>
);
